export async function decodeWaveformPeaks(file, barCount = 240) {
  const arrayBuffer = await file.arrayBuffer();
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return null;

  const audioContext = new AudioCtx();
  try {
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer.slice(0));
    const channel = audioBuffer.getChannelData(0);
    const samplesPerBar = Math.floor(channel.length / barCount) || 1;
    const peaks = new Float32Array(barCount);

    for (let i = 0; i < barCount; i += 1) {
      const start = i * samplesPerBar;
      let max = 0;
      for (let j = 0; j < samplesPerBar; j += 1) {
        const v = Math.abs(channel[start + j] || 0);
        if (v > max) max = v;
      }
      peaks[i] = max;
    }

    let peakMax = 0;
    for (let i = 0; i < peaks.length; i += 1) {
      if (peaks[i] > peakMax) peakMax = peaks[i];
    }
    if (peakMax > 0) {
      for (let i = 0; i < peaks.length; i += 1) {
        peaks[i] /= peakMax;
      }
    }

    return peaks;
  } catch {
    return null;
  } finally {
    await audioContext.close();
  }
}

export function formatTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, "0")}`;
}
